/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import SectionData from 'components/machine/sectionData';
import { LocalizedText } from '@umati/dashboard-types';
import './SurfaceProcess.scss';
import { labels } from '@umati/dashboard-common';

export interface ISurfaceStateProps {
  OperationalHours?: number;
  OperationalState?: {
    CurrentState?: LocalizedText;
  };
  PowerOnHours?: number;
}

export default function SurfaceState(props: ISurfaceStateProps) {
  const colStyle = 'col-12 col-sm-6 col-md-4';
  return (
    <div className="section surfaceState">
      <div className="row">
        {props.OperationalHours !== undefined && (
          <SectionData cols={colStyle} label={labels.operationalHours} value={props.OperationalHours} />
        )}
        {props.OperationalState !== undefined && (
          <SectionData
            cols={colStyle}
            label={labels.operationalState}
            value={props.OperationalState?.CurrentState?.text}
          />
        )}
        {props.PowerOnHours !== undefined && (
          <SectionData cols={colStyle} label={labels.powerOnHours} value={props.PowerOnHours} />
        )}
      </div>
    </div>
  );
}
